import React from 'react';
import Head from 'next/head';
import styles from './eula.module.scss';

const isAllCapsHeading = (text) => {
  if (!text) return false;
  return /^[A-Z0-9][A-Z0-9\s“”"'’.,:&()-]+$/.test(text);
};

const isTitleCaseHeading = (text) => {
  if (!text) return false;
  return /^[A-Z][A-Za-z0-9“”"'’.,:&()-]*(?:\s+[A-Z][A-Za-z0-9“”"'’.,:&()-]*)*$/.test(
    text
  );
};

const isNumberedHeading = (text) =>
  /^\d+(?:\.\d+)*\.?\s+\S+/.test(String(text || '').trim());

const renderPolicyContent = (content) => {
  const lines = String(content || '').replace(/\r\n/g, '\n').split('\n');

  const nodes = [];
  let paragraphLines = [];

  const flushParagraph = () => {
    if (!paragraphLines.length) return;
    const text = paragraphLines.join('\n').trim();
    paragraphLines = [];
    if (!text) return;
    nodes.push({ type: 'p', text });
  };

  for (const rawLine of lines) {
    const line = String(rawLine || '').trim();

    if (!line) {
      flushParagraph();
      continue;
    }

    const isEffectiveDate = /^Effective Date:/i.test(line);
    const isHeading =
      !isEffectiveDate &&
      line.length <= 120 &&
      (isNumberedHeading(line) || isAllCapsHeading(line) || isTitleCaseHeading(line));

    if (isHeading) {
      flushParagraph();
      nodes.push({ type: 'h2', text: line });
      continue;
    }

    if (isEffectiveDate) {
      flushParagraph();
      nodes.push({ type: 'p-effective', text: line });
      continue;
    }

    paragraphLines.push(rawLine);
  }

  flushParagraph();

  return nodes.map((node, index) => {
    if (node.type === 'h2') {
      return (
        <h2 key={`h2-${index}`} className={styles.h2}>
          {node.text}
        </h2>
      );
    }

    if (node.type === 'p-effective') {
      return (
        <p
          key={`p-effective-${index}`}
          className={`${styles.paragraph} ${styles.effectiveDate}`}
        >
          {node.text}
        </p>
      );
    }

    return (
      <p key={`p-${index}`} className={styles.paragraph}>
        {node.text}
      </p>
    );
  });
};

export default function ConjureEulaPage({ content }) {
  return (
    <div className={styles.page}>
      <Head>
        <title>Conjure End User License Agreement</title>
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>

      <main className={styles.container}>
        <article className={styles.content}>{renderPolicyContent(content)}</article>
      </main>
    </div>
  );
}

export async function getStaticProps() {
  const fs = require('fs');
  const path = require('path');

  const filePath = path.join(
    process.cwd(),
    'src',
    'content',
    'conjure',
    'eula.content.txt'
  );

  const content = fs.readFileSync(filePath, 'utf8');

  return {
    props: {
      content,
    },
  };
}
